import React from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";

export default function LabourRebortsearch() {
  return (
    <Fragment>
      <div className="row customers ">
        <div className="col-sm-12 laborReport">
          <h2>Labor Report</h2>
        </div>
      </div>
    </Fragment>
  );
}
